import withLocale from '../../withLocale';
import OSSFilePreviewInner from './OSSFilePreviewInner';

const OSSFilePreview = withLocale(OSSFilePreviewInner);

export { OSSFilePreviewInner };
export default OSSFilePreview;
